import { useCallback, useEffect, useState } from 'react';
import { SchwachstelleList } from '../../../types';
import { schwachstellenService } from '../../../services/schwachstellenService';

export const useAuditFindings = (auditId: number | null) => {
  const [schwachstellen, setSchwachstellen] = useState<SchwachstelleList[]>([]);
  const [loadingSchwachstellen, setLoadingSchwachstellen] = useState(false);

  const reloadSchwachstellen = useCallback(async () => {
    if (!auditId) return;

    try {
      setLoadingSchwachstellen(true);
      const data = await schwachstellenService.list({ audit_id: auditId });
      setSchwachstellen(data);
    } catch (error) {
      console.error('Fehler beim Laden der Schwachstellen:', error);
    } finally {
      setLoadingSchwachstellen(false);
    }
  }, [auditId]);

  useEffect(() => {
    void reloadSchwachstellen();
  }, [reloadSchwachstellen]);

  return {
    schwachstellen,
    setSchwachstellen,
    loadingSchwachstellen,
    reloadSchwachstellen,
  };
};
